export const locationKind = {
  port: "Port",
  railTerminal: "Rail terminal",
  airport: "Airport",
  roadTerminal: "Road terminal",
};
